document.querySelectorAll('.annotate').forEach(function (contentEl) {
  const strongTags = contentEl.querySelectorAll('p > strong:not(:has(em)');
  const emTags = contentEl.querySelectorAll('p > em:not(:has(strong))');

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          strongTags.forEach(function (el) {
            const annotation = RoughNotation.annotate(el, {
              type: 'underline',
              animate: true,
              multiline: true,
              color: '#ad0303',
              strokeWidth: 1,
            });
            annotation.show();
          });
          emTags.forEach(function (el) {
            const annotation = RoughNotation.annotate(el, {
              type: 'circle',
              animate: true,
              color: '#ad0303',
              strokeWidth: 1,
            });
            annotation.show();
          });
          observer.disconnect();
        }
      });
    },
    { threshold: 0.1 },
  );

  observer.observe(contentEl);
});
